<template>
  <div>
    <div>
      <b>ユーザID</b>
      <span class="pr-3">： {{ consultation.userId }}</span>
    </div>
    <div>
      <span><b>クーポン名</b>： {{ consultation.userCouponName }}</span>
    </div>
    <div>
      <span><b>学年</b>： {{ consultation.reservedGrade }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnytimeConsultationPediatricianYouthUserInfo",
  props: {
    consultation: {
      type: Object,
      default: null
    },
  },
};
</script>
